import { DetailsTreeItemValue } from "@synota-io/synota-shared-ui";

export function getUrlTitle(url: string | undefined) {
  return url?.split("://")[1] || url || "Untitled";
}

export const buildTreeItems = (
  data: any,
  parentId: string,
  prefix: string = "",
): DetailsTreeItemValue[] => {
  if (data === null || data === undefined) {
    return [{ id: `${parentId}_no_data`, label: "N/A", value: "Not configured" }];
  }
  return Object.entries(data).map(([key, value], index) => {
    const itemId = `${parentId}_${prefix}${key}_${index}`;
    if (value && typeof value === "object" && !Array.isArray(value)) {
      return {
        id: itemId,
        label: key,
        children: buildTreeItems(value, itemId, `${prefix}${key}_`),
      };
    }
    return {
      id: itemId,
      label: key,
      value: value !== null && value !== undefined ? value.toString() : "N/A",
    };
  });
};
